<template>
  <div class="ActivityDiscount">
    <div class='titlebg'>
      <img  class="bg" :src="imgUrl1" alt=""  >
      <img  class="bg" :src="imgUrl2" alt=""  >
      <div class="btns">一键领取</div>
    </div>
    <div class="btn btn1">
      <div @click="getActivityDiscount(2)"></div>
    </div>
  </div>
</template>
<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'summer',
  data(){
    return {
      imgUrl1: 'https://cms.dafang24.com/aliapp/20191012/sumOne.png',
      imgUrl2: 'https://cms.dafang24.com/aliapp/20191012/sumTwo.png',
      couponList2: [
       {
          name: "2天减50元",
          OfferID: 303
        },
        {
          name: "4天减120元",
          OfferID: 302
        },
        {
          name: "7天减210元",
          OfferID: 301
        }
      ],
    }
  },
  created () {},
  mounted () {},
  methods: {
    getActivityDiscount(type=0){
      if( localStorage.getItem('token') ){
        let couponList = this.couponList2;
        this.consumerCouponsFn(couponList);
      } else {
        this.flexible.showToast({
            content: '请登录/注册！',
            duration: 1200,
            success: ()=>{
               //console.log('调用原生方法跳转登录');
              if( orderSource==17 ){
                window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
              } else if ( orderSource==16 ){
                dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
              }
            }
          });
      }
    },
    goHome () {
      if( orderSource==17 ){
        window.webkit.messageHandlers.goHome.postMessage(null);
      } else if ( orderSource==16 ){
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn (copList) { // 获取用户优惠券
      let res = await getConsumerCoupons();
      if( res.Code==100 ){
        let uCoupon = res.Data || [];
        if( uCoupon.length ){
          for( let i in uCoupon ){
            for( let j in copList ){
              if( uCoupon[i].OfferID == copList[j].OfferID ){
                copList.splice(j, 1)
              }
            }
          }
        }
        if( copList.length ){
          let lastRes = false;
          for( let item of copList ){
            let gRes = await this.getDrawCoupon(item.OfferID);
            if( gRes ){ lastRes = gRes }
          }
          if( lastRes ){
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！去租车',
              success:()=>{
                this.goHome()
              }
            });
          } else {
            this.flexible.showToast({content:'领取失败，请重试'})
          }
        } else {
          this.flexible.showToast({
            duration:1200,
            content:'领取成功！去租车',
            success:()=>{
              this.goHome()
            }
          })
        }
      }
    },
    async getDrawCoupon ( offerID ) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0
        },
        isLoading: 1,
        loadContent: '获取优惠券...'
      });
      if( res.Code==100 ){
        return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      div {
        display: inline-block;
        /*background-color: rgba(0,0,0, .5);*/
      }
    }
    .btn1 {
      top: 1380px;
      div {
        width: 400px;
        height: 120px;
      }
    }
  }
  .titlebg{
        position: relative;
    }
  .titlebg .bg{
        width:100%;
        height:100%;
    }
  .titlebg .btns{
      width:348px;
      height:90px;
      background:rgba(188,213,85,1);
      opacity:1;
      border-radius:50px;
      font-size:32px;
      position: absolute;
      left:200px;
      top:1400px;
      text-align: center;
      line-height: 90px;
      color:#587F08;
    }

</style>